import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import SvgIcon from '../SvgIcon.vue';
import CloseIcon from '../../icons/CloseIcon.vue';
import { addSuffix } from '../../../../utils/utils';
import useZIndex from '../../../../hooks/useZIndex';

type DoneFn = () => void;
type BeforeCloseFn = (done: DoneFn) => void;
type ConfirmFn = () => void;
type CancelFn = () => void;

interface Props {
  title?: string;
  value?: boolean;
  modal?: boolean;
  width?: string | number;
  beforeClose?: BeforeCloseFn | null;
  closeOnClickModal?: boolean;
  showClose?: boolean;
  appendToBody?: boolean;
  appendToRoomContainer?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogPC',
  props: {
    title: { default: '' },
    value: { type: Boolean, default: false },
    modal: { type: Boolean, default: false },
    width: { default: undefined },
    beforeClose: { type: [Function, null], default: null },
    closeOnClickModal: { type: Boolean, default: true },
    showClose: { type: Boolean, default: true },
    appendToBody: { type: Boolean, default: false },
    appendToRoomContainer: { type: Boolean, default: false }
  },
  emits: ['input', 'close'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, value: boolean, modal: boolean, width: string | number, beforeClose: BeforeCloseFn | null, closeOnClickModal: boolean, showClose: boolean, appendToBody: boolean, appendToRoomContainer: boolean }





const { nextZIndex } = useZIndex();

const overlayContainerStyle = ref({});

const visible = ref(false);

const dialogRef = ref();

const drawerContainerStyle = computed(() => {
  let style = '';
  if (props.width) {
    style += `--tui-dialog-width: ${addSuffix(props.width)}`;
  }
  return style;
});

watch(
  () => props.value,
  (val) => {
    visible.value = val;
  },
);

watch(visible, (val) => {
  if (val) {
    overlayContainerStyle.value = { zIndex: nextZIndex() };
    if (props.appendToBody) {
      document.body.appendChild(dialogRef.value);
    } else if (props.appendToRoomContainer) {
      document.getElementById('roomContainer')?.appendChild(dialogRef.value);
    }
  }
});

function doClose() {
  visible.value = false;
  emit('close');
  emit('input', false);
}

function handleClose() {
  if (props.beforeClose) {
    props.beforeClose(doClose);
  } else {
    doClose();
  }
}

function handleOverlayClick(event: any) {
  if (!props.closeOnClickModal) {
    return;
  }
  if (event.target !== event.currentTarget) {
    return;
  }
  handleClose();
}

return { __sfc: true,props, emit, nextZIndex, overlayContainerStyle, visible, dialogRef, drawerContainerStyle, doClose, handleClose, handleOverlayClick, SvgIcon, CloseIcon }
}

})